export const resizeImageUrl = (url: string, width: number): string =>
    url.replace('/upload/', `/upload/w_${width}/`);
